module.exports = [
  {
    name: 'settings',
    actions: 'all'
  }
]
